import fetch from '../../api/fetch';
import { REDUX_ACTIONS } from '../../shared/config/constants';
import { parseError } from '../../utils/fetchErrorParser';
import { enqueueSnackbar } from './snackbar';

export const fetchAssetsMap = () => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.ASSETS_MAP_LIST_LOADING,
  });

  return fetch
    .post('assets/map')
    .then((resp) => {
      if (!resp.ok) {
        return Promise.reject(resp);
      }
      return resp.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.ASSETS_MAP_LIST_SUCCESS,
        payload: {
          data: [...data.map((item) => ({ ...item, _id: item.grid_id }))],
          paginatedElements: data.length,
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);

      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.ASSETS_MAP_LIST_ERROR,
        payload: { ...error, message: errorMessage },
      });
    });
};
